var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubstancePainter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2238 2186",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M848.5,117.884c12.41,-76.462 84.563,-128.463 161.024,-116.053c76.462,12.41 128.464,84.562 116.054,161.024c-12.41,76.462 -84.563,128.463 -161.025,116.053c-76.461,-12.41 -128.463,-84.562 -116.053,-161.024Z",
    style: {
      fill: "#e1262f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2016.79,
    cy: 1963.98,
    r: 221.207,
    style: {
      fill: "#e1262f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.636,
    cy: 1963.98,
    r: 97.636,
    style: {
      fill: "#e1262f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.039,459.772c-472.924,0 -855.841,382.916 -855.841,855.841c0,472.924 382.917,855.84 855.841,855.84c472.924,0 855.84,-382.916 855.84,-855.84c0,-472.925 -382.916,-855.841 -855.84,-855.841Zm-579.714,523.268l578.188,-334.098l576.663,334.098l-0,302.061l-265.448,-85.431l0,-62.548l-311.215,-180.016l-228.834,132.723l805.497,257.821l-0,302.061l-578.188,334.098l-578.188,-332.573l-0,-303.586l266.973,83.905l0,62.548l311.215,180.017l231.885,-134.25l-808.548,-256.294l0,-300.536Z",
    style: {
      fill: "#e1262f",
      fillRule: "nonzero"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubstancePainter);
export default __webpack_public_path__ + "static/media/substance-painter.efa9ce2e375297257863f41fe6e80e03.svg";
export { ForwardRef as ReactComponent };